import { tabsAnatomy } from "@chakra-ui/react/anatomy";
import { defineSlotRecipe } from "@chakra-ui/react/styled-system";
import { interactiveTransition } from "./_shared";

export default defineSlotRecipe({
  slots: tabsAnatomy.keys(),
  base: {
    trigger: {
      ...interactiveTransition,
    },
  },
  variants: {
    variant: {
      line: {},
      subtle: {
        trigger: {
          height: "auto",
          minWidth: "auto",
        },
      },
    },
    inboxSettings: {
      true: {
        content: {
          display: "flex",
          flexDirection: "column",
          gap: "6",
        },
      },
    },
    // Fills the page area it sits in: the triggers stay put and the panel
    // scrolls (Settings → Inboxes). Page.Content clips its overflow.
    fillHeight: {
      true: {
        root: {
          flex: "1",
          minHeight: "0",
          width: "full",
          paddingInline: { base: "2", md: "4" },
          paddingTop: "2",
          _horizontal: {
            display: "flex",
            flexDirection: "column",
          },
        },
        list: {
          flexShrink: "0",
        },
        content: {
          flex: "1",
          minHeight: "0",
          overflowY: "auto",
        },
      },
    },
  },
  defaultVariants: {
    variant: "line",
  },
});
